import { fr } from 'date-fns/locale/fr';
import { enUS } from 'date-fns/locale/en-US';
import { enAU } from 'date-fns/locale/en-AU';
import { format as formatFns } from 'date-fns';
import { isoDatePattern } from './datePatterns';
import { UserLocale } from '@teetsh/app/src/types/user';

function getDateFnsLocale(localeString: UserLocale) {
  switch (localeString) {
    case 'en-US':
      return enUS;
    case 'en-AU':
      return enAU;
    case 'fr-BE':
    case 'fr-FR':
      return fr;
  }
}

export function format(
  date: Date,
  localeString: UserLocale,
  pattern?: string,
): string {
  const locale = getDateFnsLocale(localeString);
  if (!pattern) {
    return formatFns(date, isoDatePattern, { locale });
  }
  return formatFns(date, pattern, { locale });
}
